'use client';
import React from 'react';
import Script from 'next/script';

const CALENDLY_BASE_URL = 'https://calendly.com/cbsdiscoverycall/30min';

const params = new URLSearchParams({
  hide_gdpr_banner: '1',
  background_color: 'ffffff',
  text_color: '571209',
  primary_color: '571209',
});

const CALENDLY_URL = `${CALENDLY_BASE_URL}?${params?.toString()}`;

export default function CalendlyEmbed() {
  return (
    <div>
      <div
        className="calendly-inline-widget w-full overflow-hidden rounded-xl bg-white"
        data-url={CALENDLY_URL}
        style={{ minWidth: '280px', height: '700px' }}
      />
      <Script
        src="https://assets.calendly.com/assets/external/widget.js"
        strategy="lazyOnload"
      />
    </div>
  );
}
